// Conversation System - Bullet Style Format
// Each conversation object contains an array of interaction text following the bullet format

export const conversations = {
  ratz: {
    name: "Ratz",
    title: "Bartender",
    location: "chatsubo",
    intro:
      "Ratz waits with a smile, his teeth a webwork of East European steel and brown decay.",
    options: [
      {
        text: "I want a drink",
        textLong: '"What do you serve around here?"',
        response: '"Kirin on draft."',
        options: [
          {
            text: "Water",
            textLong: "Water will do.",
            response:
              '"Lightweight, eh," his seven-function prosthetic hand fills a mug with a paper carton Apollonaris water. "You have a problem with my beer?"',
            options: [
              {
                text: "No",
                textLong:
                  "Just following the samurai code. Temperance at all times.",
                response:
                  '"I appreciate a man of honor. You from around here?"',
                options: [
                  {
                    text: "Yeah",
                    textLong:
                      '"I was born on the other side of the island. Never knew my parents. Died when I was little. Orphaned and taken in by a Samurai. A Ronin. He taught me what I know."',
                    response: '"And that explains the kung fu earlier?"',
                    options: [
                      {
                        text: "Yeah",
                        textLong:
                          '"I want to cleanup Night City. It\'s my personal mission."',
                      },
                    ],
                  },
                  {
                    text: "Not your business",
                    response:
                      "Ratz shrugs and turns to the next customer, a console cowboy from the Sprawl.",
                  },
                ],
              },
              {
                text: "Yes",
                textLong:
                  '"Yeah, it stinks like your antique rig. Do you scratch your fat crack with that force-feedback manipulator?"',
                response:
                  '"An artiste!" he laughs. "Just for tonight, I let you hang around for entertainment."',
              },
            ],
          },
          {
            text: "Beer",
            textLong: '"Kirin will do."',
            response:
              '"I\'m surprised," his seven-function prosthetic hand yanks a handle and fills a mug. "You look like one of those samurai types to me. Code of Honor and all that shit."',
            options: [
              {
                text: "Excuse me?",
                textLong: '"Not your business, is it?"',
                response:
                  "Ratz's force-feedback manipulator buzzes, joints whining, before extending a grubby pink plastic middle finger.",
              },
              {
                text: "Correct",
                textLong:
                  "That's right. Just hanging up my armor for the evening is all.",
                response:
                  '"In Night City, never remove it... You from around here?"',
                options: [
                  {
                    text: "Yeah",
                    textLong:
                      '"I was born on the other side of the island. Parents died when I was little. Taken in by a Samurai. A Ronin, who trained me."',
                    response:
                      '"And that explains the speed and the chops earlier?" Ratz asks, swinging his proshetic arm.',
                    options: [
                      {
                        text: "Yeah",
                        textLong:
                          '"I want to cleanup Night City. It\'s my personal mission."',
                      },
                    ],
                  },
                  {
                    text: "Not your business",
                    response:
                      "Ratz shrugs and turns to the next customer, a console cowboy from the Sprawl.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        text: "I want to earn money",
        textLong: '"What do you do to earn a quick buck around here?"',
        response: '"Above the law ... or below?"',
        options: [
          {
            text: "Legal",
            textLong: '"Samurai here. Bushido, Code of Honor."',
            response:
              '"Bullshito, eh? Out to save the world? For that biz go to Ninsei Strip. Junkies likes that last one who I would appreciate off the streets. Knock a few over and you might find some loose credit chips or extra New Yen."',
            options: [
              {
                text: "Anything else?",
                response:
                  "\"There's also the arcade. If you're quick with a stick at Tank War Europe, you might walk out with a roll.\"",
              },
            ],
          },
          {
            text: "Illegal",
            textLong: '"I\'ll do whatever it takes."',
            response:
              'Ratz eyes you nervously, wiping the sweat from his bald head with a grimy rag. "If you\'re looking for biz, a gaijin dealer named Wage runs the neighborhood. Deals mostly in proscribed biologicals. Do biz in Night City, you work with Wage … or end up with a hole in your face."',
            options: [
              {
                text: "Where do I find Wage?",
                response:
                  '"A bar down the street. The Namban. But don\'t tell him I sent you."',
              },
            ],
          },
        ],
      },
      {
        text: "Tell me about Night City",
        textLong: '"What can you tell me about Night City?"',
        response:
          "\"Ninsei is mostly foreigners, gaijin, sailors. We're wedged between the port and corporate arcologies of Chiba City. If you're here for biz, stop hustling and you sink without a trace. Dealers run this neighborhood. Drugs, black clinics, junkies. I wouldn't mind seeing the neighborhood cleaned up. Better for business.\"",
        loopBack: true,
        options: [
          {
            text: "Black clinics?",
            textLong: '"What\'s a black clinic?"',
            response:
              '"People come from all over the world to pay for the black clinics of Chiba. But the experimentation happens here in Night City. And how the organs are supplied. That\'s why the Yakuza and zaibatsu allow this shithole to exist."',
          },
          {
            text: "Drugs?",
            textLong: '"What kind of drugs?"',
            response:
              '"Biologicals, derms, octagons, cloud dancers. You name it, you can find it in Night City. I stay away from that shit, but it\'s also what brings the foreigners."',
          },
          {
            text: "Cleanup?",
            textLong: '"You\'ve got my ear. What kind of clean up?"',
            response:
              "\"On Ninsei Strip, the streets crawl with junkies and street surgeons—enough to get you rolled straight into a black clinic … unless you don't mind waking up short a few vital organs. Also some money to be made if you're a Bullshito badass like yourself.\"",
          },
        ],
      },
      {
        text: "Tell me about Chiba City",
        textLong: '"What can you tell me about Chiba City?"',
        response:
          '"Chiba City includes the port, Night City, and then the corporate arcologies of the city. These are the enclaves where the employees of the zaibatsus live and work. Hosaka, Mitsubishi-Genentech, Ono-Sendia. Chiba is the center of the world when it comes to top-of-the-line software, hardware, biotech — and black clinics."',
        loopBack: true,
        options: [
          {
            text: "Zaibatsu?",
            response: '"Japanese for megacorp."',
          },
          {
            text: "Black clinics?",
            response:
              '"People travel from all over to pay for upgrades in Chiba. But the experimentation happens here in Night City. And how the organs are supplied. That\'s why the Yakuza and zaibatsu allow this shithole to exist."',
          },
        ],
      },
      {
        text: "Tell me about the crime",
        textLong: '"Who runs the neighborhood?"',
        response:
          '"A biologicals dealer named Wage. And his joeboys. Graftees, muscle-boys."',
        loopBack: true,
        options: [
          {
            text: "Tell me more about Wage",
            response:
              '"A gaijin dealer. Foreigner. Deals in genetic materials and hormones. Has connections to organized crime in a dozen cities beyond Night City\'s borders. But I warn you, Herr. Mess with Wage, he will sink your ass to the bottom of the bay."',
            options: [
              {
                text: "Where do I find Wage?",
                response:
                  '"Namban, a bar down the street. But don\'t tell him I sent you."',
              },
            ],
          },
        ],
      },
      {
        text: "Got any advice?",
        textLong:
          '"You look like you\'ve been around here a while. Any other advice?"',
        response:
          '"You feel fear? Listen to the fear. Maybe it\'s your friend. You from around here?"',
        options: [
          {
            text: "Yeah",
            textLong:
              '"I was born on the other side of the island. Never knew my parents. Died when I was little. Orphaned and taken in by a Samurai. A Ronin. He taught me what I know."',
            response: '"And that explains the kung fu earlier?"',
            options: [
              {
                text: "Yeah",
                textLong:
                  '"I want to cleanup Night City. It\'s my personal mission."',
              },
            ],
          },
          {
            text: "Not your business",
            response:
              "Ratz shrugs and turns to the next customer, an African sailor, who just swaggered in from port.",
          },
        ],
      },
    ],
  },
  lonny_zone: {
    name: "Lonny Zone",
    title: "Pimp",
    location: "chatsubo",
    intro:
      "The bar's resident pimp, Lonny observes with glazed fatherly interest as one of his girls goes to work on ayoung sailor.",
    options: [
      {
        text: "Tell me about Night City",
        textLong: '"Tell me about Night City"',
        response:
          '"Chiba is the big city," he tucks his hands into the pockets of his gray sharkskin slacks. "But Night City is where the sailors and other foreigners come to play. You looking for some fun, tonight?"',
        options: [
          {
            text: "What kind of fun?",
            textLong: '"What kind of fun?"',
            response:
              '"Girls," the pimp snaps his fingers at a woman in the corner. "Or Cloud Dancer is my drug of choice. But you don\'t look the the kind of guy looking for a good time."',
            options: [
              {
                text: "Correct",
                textLong:
                  '"I\'m here to clean up the streets, not make them worse."',
                response:
                  '"Ah, a crusader," he says with a dead gaze, high from something. "Remind me to stay away from you."',
              },
              {
                text: "Maybe I am",
                textLong: '"Maybe I am."',
                response:
                  '"Then head down to Ninsei Strip. That\'s where you can find the good stuff."',
              },
            ],
          },
          {
            text: "No",
            textLong:
              '"I\'m here to cleanup the streets. Where can I find the local trouble?"',
            response:
              "Lonny faces his palms up. \"Cool it, baby. You an enforcer or something? If you're looking for trouble go to Ninsei Strip. Although don't tell them Lonny said so.\"",
          },
        ],
      },
      {
        text: "What are you looking at?",
        textLong: '"What are you looking at?"',
        response:
          'Lonny laughs real slow, "I just thought you might be interested in one of my girls."',
        options: [
          {
            text: "Wrong",
            textLong: '"I\'m here to cleanup the streets, not corrupt them."',
            response:
              'Lonny holds his palms up, "Fine by me, baby. Just leave me and my girls alone."',
          },
        ],
      },
      {
        text: "I want to earn money",
        textLong: '"What can I do to earn some money around here?"',
        response:
          '"The thugs on Ninsei Strip could use some roughing up. They\'ve been chasing my business away for a while. Sailors drop in to be with my girls, but after a few muggings, they stop coming around."',
        options: [
          {
            text: "Anything else?",
            textLong: '"Anything else?"',
            response:
              '"If you\'re good with a joystick try the arcade." His pupils are dilated and enormous. "But I never did win. Spend most of my time high or keeping my girls employed."',
          },
        ],
      },
      {
        text: "I need a weapon",
        textLong:
          '"Samurai here. I need some tools of the trade, if you see what I mean."',
        response:
          '"Of course, baby," he says tucking his hands into his sharkskin slacks. "A kid by the name of Shin has a seafood stall. Talk to him."',
      },
      {
        text: "I need a place to stay",
        textLong: "I'm looking for a place to stay the night.",
        response: "You got money?",
        options: [
          {
            text: "No",
            textLong: "You shake your head.",
            response:
              "There's Cheap Hotel near the docks on Baiitsu. Rent a coffin for low price.",
            options: [
              {
                text: "A coffin?",
                response:
                  '"Yeah, a bed about this long," he stretches out his arms. "A capsule. But not the only reason they call it a coffin…"',
              },
            ],
          },
          {
            text: "Yes",
            textLong: "You nod your head.",
            response:
              "I think you're lying. But when you have the rolls for it, I hear the Chiba Hilton uptown is a nice place. There you actually rent a room.",
          },
        ],
      },
    ],
  },
  sailor: {
    name: "Sailor",
    title: "Sailor",
    location: "chatsubo",
    intro:
      "A tall sailor drinks Kirin at the bar. His arms is around one of Lonny's girls.",
    options: [
      {
        text: "What are you doing here?",
        textLong: "Why are you in Night City?",
        response:
          "My ship's port for the evening. Just trying to have myself a good time.",
        options: [
          {
            text: "Doing what?",
            response: "None of your business.",
          },
        ],
      },
      {
        text: "You like this bar?",
        response:
          '"Yes," he says raising his beer with a grin. "Ratz always treats me right. And Lonny supplies me with girls."',
      },
      {
        text: "You run into any trouble?",
        response:
          '"Ya, man. Last time I was in port, a gang thumped me on Ninsei Strip. Took all my credits and a gold tooth." He opens his mouth to show you the evidence.',
      },
    ],
  },
};

// Helper function to get conversation by character ID
export const getConversation = (characterId) => {
  return conversations[characterId] || null;
};

// Helper function to get all characters in a location
export const getCharactersInLocation = (locationId) => {
  return Object.values(conversations).filter(
    (char) => char.location === locationId
  );
};
